import React from "react";
import Particles from "react-particles-js";
import { ParticleConfig } from "./ParticleConfig";

function ParticlesBackground() {
  return (
    <div>
      <Particles
        params={ParticleConfig}
        style={{
          top: 0,
          left: 0,
          position: "absolute",
        }}
      />
    </div>
  );
}

export default ParticlesBackground;
